<template>
    <div class="wrap">
         <Header></Header>
        <div class="p-card">

        </div>
        <div class="inner-wrap">
            <div class="main-content">
                <div class="btn-group">
                    <div class="item active">VR</div>
                    <div class="item">效果图</div>
                    <div class="item">实景图</div>
                    <div class="total">共97张</div>
                </div>
                <div class="main-wrap">
                   <div class="h-title">
                        <h1>北京经开壹中心</h1>
                        <div class="status">在售</div>
                   </div>
                   <div class="btns-wrap">
                        <div class="new-n">
                            新一代互联网
                        </div>
                        <div class="zhineng">
                            人工智能
                        </div>
                        <div class="high-jishu">
                            高新技术
                        </div>
                        <div class="shuzimeiti">
                            数字媒体
                        </div>
                    </div>
                    <ul class="itemdesc-wrap">
                       <li class="price-wrap">
                           <div class="label price">租售价格</div>
                            <div class="content"><span class="big">27000</span><span>元/平方米</span></div>
                        </li> 
                        <li>
                            <div class="label">
                                楼盘位置
                            </div>
                            <div class="content">
                                北京西区
                            </div>
                        </li>
                        <li>
                            <div class="label">地铁线路</div>
                            <div class="content">海路站</div>
                        </li>
                        <li>
                            <div class="label">项目特色</div>
                            <div class="content">产业综合体/综合开发园区</div>
                        </li>
                        <li>
                            <div class="label">开发商</div>
                            <div class="content">北京经开投资开发股份有限公司</div>
                        </li>
                    </ul>
                    <div class="more-btn">
                        <div class="inner">更多信息</div>
                    </div>
                     <div class="clicks-btn">
                       <div class="inner">
                            <div class="view">关注</div>
                            <div class="store">收藏</div>
                            <div class="share">分享</div>
                            <div class="show">考察楼盘</div>
                       </div>
                    </div>
                    <div class="user-wrap">
                        <div class="left">
                            <div>拨打电话免费咨询</div>
                            <div>400-0080-960转14228</div>
                        </div>
                        <div class="right">
                            <div class="inner-left"></div>
                            <div class="inner-right">
                                <div>
                                    <span class="name">陈思成</span>
                                    <span>选址顾问</span>
                                </div>
                                <div>
                                    大兴区选址顾问
                                </div>
                                <div class="introduence">
                                    咨询
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="house-wrap">
                        <div class="title">
                            <div class="left">楼盘详情</div>
                            <div class="right"><span>查看更多</span><van-icon name="arrow" /></div>
                        </div>
                        <p class="content">
                            北京经开・壹中心总建筑面积29万平米，涵盖5A写字楼、精品商业、企业独栋、生态美宅四大产品形态，
                            分两期建设，一期企业独栋和住宅总建筑面积约15.6万，现已全部入驻。二期四栋5A级写字楼和商业为目前在售
                            部分，总建筑面积约13.4万m，于2020年4月实景呈现
                        </p>
                    </div>
                    <div class="house-type">
                        <div class="title">
                            <div class="left">主力户型（12）</div>
                         <div class="right"><span>查看更多</span><van-icon name="arrow" /></div>
                        </div>
                        <div gutter="80" class="photos" type="flex" justify="space-between">
                            <div class="item" span="8">
                                <div class="inner">
                                     <img src="../assets/images/typedetail.png" alt="">
                                </div>
                                <div class="in-title">标题</div>
                                <div class="in-subtitle">建筑面积约2000平米</div>
                                <div class="in-status">状态</div>
                            </div>
                            <div class="item" span="8">
                                <div class="inner">
                                    <img src="../assets/images/typedetail.png" alt="">
                                </div>
                                <div class="in-title">标题</div>
                                <div class="in-subtitle">副标题</div>
                                <div class="in-status">状态</div>
                            </div>
                            <div class="item" span="8">
                                <div class="inner">
                                   <img src="../assets/images/typedetail.png" alt=""> 
                                </div>
                                <div class="in-title">标题</div>
                                <div class="in-subtitle">副标题</div>
                                <div class="in-status">状态</div>
                            </div>
                        </div>
                    </div>
                    <div class="house-source">
                        <div class="title">
                            <div class="left">房源</div>
                            
                            <div class="right"><span>查看更多</span><van-icon name="arrow" /></div>
                        </div>
                    </div>
                    <div class="select-wrap">
                        <div class="all">全部（5套）</div>
                        <div class="area">面积</div>
                        <div class="price">单价</div>
                        <div  class="status">状态</div>
                        <div  class="key">特色</div>
                    </div>
                    <div class="select-content">
                        <div class="img-wrap"></div>
                        <div class="area">
                            <span>432</span>
                            <span class="gray">㎡</span>
                        </div>
                        <div class="price">
                            <span>3</span>
                            <span class="gray">元/㎡/天</span>
                        </div>
                        <div class="status">
                           待租
                        </div>
                        <div class="key">
                           <div class="item top">精装修</div>
                           <div class="item center">押一付三</div>
                           <div class="item bottom">可注册</div>
                        </div>
                    </div>
                     <div class="traffic-wrap">
                        <div class="title">
                            交通配套
                        </div>
                        <div id="map" class="map">
                            
                        </div>
                        <div class="photos">
                            <div class="item">
                                <div class="top"></div>
                                <div class="bottom">公交</div>
                            </div>
                            <div class="item">
                                <div class="top"></div>
                                <div class="bottom">公交</div>
                            </div>
                            <div class="item">
                                <div class="top"></div>
                                <div class="bottom">公交</div>
                            </div>
                            <div class="item">
                                <div class="top"></div>
                                <div class="bottom">公交</div>
                            </div>
                            <div class="item">
                                <div class="top"></div>
                                <div class="bottom">公交</div>
                            </div>
                            <div class="item">
                                <div class="top"></div>
                                <div class="bottom">公交</div>
                            </div>
                            <div class="item">
                                <div class="top"></div>
                                <div class="bottom">公交</div>
                            </div>
                            <div class="item">
                                <div class="top"></div>
                                <div class="bottom">公交</div>
                            </div>
                        </div>
                    </div>
                     <div class="house-news">
                        <div class="title">
                            <div class="left">最新动态</div>
                             <div class="right"><span>查看详情</span><van-icon name="arrow" /></div>
                        </div>
                        <div  class="photos">
                            <div class="item">
                               <div class="left">

                               </div>
                               <div class="right">
                                    <div class="head">
                                       <div class="start">共渡难关</div>
                                       <div class="end">
                                           <div class="inner">北京经开推出支持中小微企业稳定发展五条 </div>
                                           </div>
                                    </div>
                                    <div class="content">
                                       北京经开积极响应北京市，开发区工委、管委会和亦庄控股推出疫情稳定增长八条措施
                                    </div>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
     import { Swipe, SwipeItem,Icon} from 'vant'
    export default {
        name: "photosview",
        data: function(){
            return {
                
            }
        },
        components: {
            Header, Footer,
            [Icon.name]:Icon,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem
        },
        mounted(){
           
        },
        methods: {

        }
    }
</script>
<style scoped lang="scss">
@import "./common.scss";
    .house-news{
        padding-bottom: px2rem(8px);
    }
    .house-news .photos .content{
        padding-left:px2rem(3px);
    }
     .house-news .photos .end{
       flex:1;
    }
    .house-news .photos .inner{
        width:px2rem(130px);
        white-space:nowrap; 
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .house-news .photos .head{
        padding-left:px2rem(3px);
        display:flex;
    }
    .house-news .photos .start{
       width:px2rem(52px)
    }
    .house-news .photos .title{
       font-size:px2rem(10px);
    }
    .house-news .photos .content{
       font-size:px2rem(9px);
       color:#828282;
    }
    .house-news .photos .item{
        align-items: center;
       display:flex;
    }
    .house-news .photos .right{
       flex:1;
    }
    .house-news .photos .left{
        width:px2rem(90px);
        height:px2rem(60px);
        background:blue;
    }
    .house-news .title .right{
        display:flex;
        align-items: center;
        color:#95999c;
    }
    .house-news .title .left{
        font-size:px2rem(13px);
    }
    .house-news .title{
        padding:px2rem(10px) 0;
        display:flex;
        justify-content: space-between;
    }
    .traffic-wrap .item{
        text-align: center;
    }
    .traffic-wrap .photos{
        padding-top:px2rem(5px);
    }
    .traffic-wrap .top{
        margin:0 auto;
        height:px2rem(30px);
        border-radius:50%;
        width:px2rem(30px);
        background:pink;
    }
    .traffic-wrap .photos{
        display:flex;
        justify-content: space-around;
    }
    #map{
        height:px2rem(100px);
        background:red;
    }
    .traffic-wrap{
        padding:px2rem(10px) 0 px2rem(10px) 0;
    }
    .traffic-wrap .title{
        padding:px2rem(10px) 0 px2rem(10px) 0;
        display:flex;
        font-size:px2rem(13px)
    }
    .select-content .top{
        background:#eaf7f4;
        width:px2rem(50px);
    }
    .select-content .center{
        margin:px2rem(2px) 0;
        width:px2rem(50px);
        background:#f7f2e9;
    }
    .select-content .bottom{
        width:px2rem(50px);
        background:#edf3f8;
    }
    .select-content .item{
        font-size:px2rem(10px);
    }
    .select-content .item{
        font-size:px2rem(10px);
    }
    .select-content .item{
        font-size:px2rem(10px);
    }
    .select-content .gray{
        color:#888;
    }
    .select-content .key{
        text-align: center;
        flex:1;
    }
    .select-wrap .key{
        text-align: center;
        flex:1;
    }
    .select-content .status{
        text-align: center;
        flex:1;
    }
    .select-wrap .status{
        text-align: center;
        flex:1;
    }
    .select-content .price{
        text-align: center;
        flex:1;
    }
    .select-wrap .price{
        text-align: center;
        flex:1;
    }

   .select-content .area{
        text-align: center;
        flex:1;
    }
    .select-wrap .area{
        text-align: center;
        flex:1;
    }
    .select-content .img-wrap{
        width:px2rem(60px);
        background:red;
        height:px2rem(60px);
    }
    .select-wrap .all{
        width:px2rem(60px);
    }
    .select-content{
        align-items: center;
        justify-content: space-around;
        display:flex;
    }
    .select-wrap{
        display:flex;
        padding:px2rem(15px) 0 px2rem(14px) 0;
        justify-content: space-around;
    }
    .house-source .title .left{
        font-size:px2rem(14px);
    }
    .house-source .title .right{
        display:flex;
        align-items: center;
        color:#94989b;
        position:relative;
        top:px2rem(10px);
    }
    .house-source{
      padding-top:px2rem(12px);  
    }
    .house-source .title{
        display:flex;
        padding:0 px2rem(13px);
        justify-content: space-between;
    }
    .house-type .inner img{
       width:100%;
       height:100%;
       display:block;
    }
    .house-type .in-status{
        background:#ff0000;
        color:#fff;
        width:px2rem(20px);
        display:flex;
        justify-content: center;
        font-size:px2rem(8px); 
    }
    .house-type .in-subtitle{
        color:#888d90;
        font-size:px2rem(10px);
    }
    .house-type .inner{
        border:px2rem(1px) solid #e6e6e6;
        padding:0 px2rem(6px);
        min-height:px2rem(80px);
    }
    .house-type .photos{
        display:flex;
        justify-content: space-around;
    }
    .house-type .photos .item{
       
        width:31%;
    }
    .house-type{
        padding:0 px2rem(13px);
    }
    .house-type .title .right{
        display:flex;
        align-items: center;
        color:#95999c;
        position:relative;
        top:px2rem(20px);
    }
    .house-type .title .left{
        font-size:px2rem(14px);
        color:#333;
        margin-top:px2rem(20px);
    }
    .house-type .title{
       display:flex;
       justify-content: space-between;
       padding-bottom:px2rem(12px);
    }
    .house-wrap .content{
        padding-top:px2rem(10px);
        padding-bottom:px2rem(16px);
    }
    .house-wrap .title .right{
        color:#95999c;
        display:flex;
        align-items: center;
        position:relative;
        top:px2rem(10px);
    }
    .house-wrap .title .left{
        font-size:px2rem(14px);
        color:#333;
        margin-top:px2rem(20px);
    }
    .house-wrap .title{
        display:flex;
        align-items: center;
        justify-content: space-between;
    }
    .house-wrap{
        padding:0 px2rem(13px);
    }
    .user-wrap .name{
        font-size:px2rem(11px);
        padding-right:px2rem(4px);
        font-weight:bold;
    }
    .user-wrap .introduence{
        background:#d30000;
        color:#fff;
        padding-left:px2rem(10px);
        width:px2rem(38px);
    }
   .user-wrap .inner-right{
        padding-left:px2rem(4px);
        padding-right:px2rem(4px);
    }
    .user-wrap .right{
        font-size:px2rem(8px);
        display:flex;
        align-items: center;
        justify-content: space-between;
    }
    .user-wrap .inner-left{
        border-radius:50%;
        width:px2rem(40px);
        height:px2rem(40px);
        background:red;
    }
    .user-wrap .left{
        padding:px2rem(8px) px2rem(10px) px2rem(6px) px2rem(20px);
    }
    .user-wrap{
        background:#efd6af;
        padding:px2rem(4px) 0;
        display:flex;
        justify-content: space-between;
        margin-top:px2rem(40px);
    }
    .clicks-btn .show{
        padding-right:px2rem(12px);
        padding-left:px2rem(20px);
        position:relative;
    }
     .clicks-btn .share{
        padding-right:px2rem(12px);
        padding-left:px2rem(20px);
        position:relative;
    }
    .clicks-btn .share:after{
        display:block;
        content:'';
        position:absolute;
        height:px2rem(10px);
        background:#2f6095;
        width:px2rem(1px);
        right:0;
        top:px2rem(3px);
        
    }
    .clicks-btn .store{
        padding-right:px2rem(12px);
        padding-left:px2rem(20px);
        position:relative;
    }
    .clicks-btn .store:after{
        display:block;
        content:'';
        position:absolute;
        height:px2rem(10px);
        background:#2f6095;
        width:px2rem(1px);
        right:0;
        top:px2rem(3px);
        
    }
    .clicks-btn .view:after{
        display:block;
        content:'';
        position:absolute;
        height:px2rem(10px);
        background:#2f6095;
        width:px2rem(1px);
        right:0;
        top:px2rem(3px);
        
    }
    .clicks-btn .view{
        padding-right:px2rem(12px);
        position:relative;
    }
    .clicks-btn{
        padding:0 px2rem(13px);
        background:#fff;
    }
    .clicks-btn .inner{
        padding:px2rem(10px) 0;
        border-top:px2rem(1px) solid #ecedee;
        background:#fff;
        justify-content: center;
        color:#2f6095;
        
        display:flex;
        align-items: center;
    }
     .more-btn .inner{
        height:px2rem(32px);
        background:#f6f6f6;
        display:flex;
        color:#e2b267;
        justify-content: center;
        align-items: center;
    }
    .more-btn{
        padding:px2rem(10px) px2rem(13px);
        background:#fff;
    }
    .itemdesc-wrap .big{
        color:#ff0000;
        font-size:px2rem(15px);
    }
    .itemdesc-wrap .price-wrap{
        margin-bottom:px2rem(8px)
    }
    .itemdesc-wrap .price{
        font-size:px2rem(15px);
        
        width:px2rem(63px)!important;
    }
    .itemdesc-wrap li{
        align-items: center;
        height:px2rem(18px);
        display:flex;
    }
     .itemdesc-wrap .label{
        display:flex;
        width:px2rem(48px);
        color:#7e8386;
    }
    .itemdesc-wrap{
        background:#fff;
        padding:px2rem(14px) px2rem(13px);
    }
        .btns-wrap{
            padding:px2rem(6px) 0 px2rem(6px) px2rem(13px);
            background:#fff;
            border-bottom:px2rem(1px) solid #f4f5f5;
        }
     .shuzimeiti{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        margin-left:px2rem(3px);
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#6da2eb;
    }
    .high-jishu{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        margin-left:px2rem(3px);
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#f3806b;
    }
    .new-n{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#ff8487;
    }
    .zhineng{
        display:flex;
        margin-left:px2rem(3px);
        padding:0 px2rem(5px);
        justify-content: center;
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#4cb41f;
    }
    .new-n{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#ff8487;
    }
    .btns-wrap{
        display:flex;
    }
    .h-title{
        background:#fff;
        display:flex;
        align-items: center;
        padding-left:px2rem(13px);
        padding-right:px2rem(13px);
        padding-top:px2rem(12px);
    }
    .h-title .status{
        margin-left:px2rem(6px);
        height:px2rem(14px);
        color:#fff;
        width:px2rem(28px);
        color:#fff;
        background:#ff0000;
        display:flex;
        justify-content: center;
        align-items: center;
        border-radius:px2rem(2px);
    }
    h1{
        font-weight:bold;
        font-size:px2rem(14px);

    }
    .btn-group{
        position:relative;
        display:flex;
        justify-content: center;
        margin-bottom:px2rem(10px);
    }
    .btn-group .total{
        background:rgba(0,0,0,.77);
        width:px2rem(40px);
        color:#fff;
        height:px2rem(16px);
        display:flex;
        font-size:px2rem(8px);
        justify-content: center;
        align-items: center;
        border-radius:px2rem(10px);
        position:absolute;
        right:0;
    }
    .btn-group .item{
        font-size:px2rem(8px);
        background:rgba(255,255,255,.87);
        margin-right:px2rem(6px);
        width:px2rem(37px);
        height:px2rem(16px);
        display:flex;
        justify-content: center;
        align-items: center;
        border-radius:px2rem(10px);
    }
    .btn-group .active{
        color:#fff!important;
        background:#3cb850!important;
    }
    .wrap{
        background:#fafafa;
    }
   .p-card{
       background:red;
       height:px2rem(200px);
   }
   .inner-wrap{
       margin-top:px2rem(-20px);
       padding:0 px2rem(9px);
   }
   .main-content{
       min-height:px2rem(200px);
   }
</style>